import { createResource } from 'react-resource-router';

import { extractWorkspace } from '../utils';

import { fetchData } from './utils';

export type Params = {
  workspaceSlug?: string;
  repositoryFullSlug?: string;
};

export const getUrl = (params: Params): string => {
  const workspaceSlug =
    params.workspaceSlug || extractWorkspace(params.repositoryFullSlug);
  return `/!api/internal/workspaces/${workspaceSlug}/pipelines-config/agentic-pipelines-configuration`;
};

export const loadAgenticPipelinesConfiguration = createResource({
  type: 'agentic-pipelines-configuration',
  getKey: ({ match }) => getUrl(match.params as Params),
  maxAge: 0,
  getData: async ({ match: { params } }) => {
    const data = await fetchData(
      getUrl(params as Params),
      'agentic_pipelines_configuration_exception'
    );

    return { enabled: data.enabled ?? false, providers: data.providers ?? {} };
  },
});
